import { makeEventFunctions } from '@deephaven/golden-layout';
export var CREATE_DASHBOARD = 'CREATE_DASHBOARD';
export var CLOSE_DASHBOARD = 'CLOSE_DASHBOARD';
var _makeEventFunctions = makeEventFunctions(CREATE_DASHBOARD),
  listenForCreateDashboard = _makeEventFunctions.listen,
  emitCreateDashboard = _makeEventFunctions.emit,
  useCreateDashboardListener = _makeEventFunctions.useListener;
export { listenForCreateDashboard, emitCreateDashboard, useCreateDashboardListener };
var _makeEventFunctions2 = makeEventFunctions(CLOSE_DASHBOARD),
  listenForCloseDashboard = _makeEventFunctions2.listen,
  emitCloseDashboard = _makeEventFunctions2.emit,
  useCloseDashboardListener = _makeEventFunctions2.useListener;
export { listenForCloseDashboard, emitCloseDashboard, useCloseDashboardListener };
//# sourceMappingURL=DashboardEvents.js.map